import { useNavigate } from 'react-router';

import { TabsType } from '~/modules/tab-content/types';
import { appPaths, queryKeys } from '~/routes/app-paths';

interface NavigateToPageProps {
  entityTag: string;
  searchParams?: URLSearchParams;
  tab?: TabsType;
}

export const useNavigateToAssetOverview = () => {
  const navigate = useNavigate();

  const navigateToAssetsOverview = (entityTag: string) => {
    const newSearchParams = new URLSearchParams();

    newSearchParams.set(queryKeys.assetOverviewAsset, entityTag);
    newSearchParams.set(queryKeys.assetOverviewTab, TabsType.Overview);

    navigate({
      pathname: appPaths.assetOverview,
      search: newSearchParams.toString(),
    });
  };

  const navigateToPage = ({
    entityTag,
    searchParams,
    tab = TabsType.Overview,
  }: NavigateToPageProps) => {
    const newSearchParams = new URLSearchParams(searchParams);

    newSearchParams.set(queryKeys.assetOverviewAsset, entityTag);
    newSearchParams.set(queryKeys.assetOverviewTab, tab);

    newSearchParams.delete(queryKeys.widget);

    navigate({
      pathname: appPaths.assetOverview,
      search: newSearchParams.toString(),
    });
  };

  return {
    navigateToChatMessage: navigateToAssetsOverview,
    navigateToPage,
  };
};
